import * as React from 'react';

const MoreActionOpenedButtonIcon = () => {
  return (
    <svg width="16" height="35" viewBox="0 0 16 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5ZM5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8Z"
        fill="#2F3741"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.5C7.17157 16.5 6.5 17.1716 6.5 18C6.5 18.8284 7.17157 19.5 8 19.5C8.82843 19.5 9.5 18.8284 9.5 18C9.5 17.1716 8.82843 16.5 8 16.5ZM5 18C5 16.3431 6.34315 15 8 15C9.65685 15 11 16.3431 11 18C11 19.6569 9.65685 21 8 21C6.34315 21 5 19.6569 5 18Z"
        fill="#2F3741"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 26.5C7.17157 26.5 6.5 27.1716 6.5 28C6.5 28.8284 7.17157 29.5 8 29.5C8.82843 29.5 9.5 28.8284 9.5 28C9.5 27.1716 8.82843 26.5 8 26.5ZM5 28C5 26.3431 6.34315 25 8 25C9.65685 25 11 26.3431 11 28C11 29.6569 9.65685 31 8 31C6.34315 31 5 29.6569 5 28Z"
        fill="#2F3741"
      />
    </svg>
  );
};

export default MoreActionOpenedButtonIcon;
